import { useQuery } from '@apollo/client';
import React, { memo } from 'react';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';

import { Redirect } from 'react-router';

const SpecificationFolderContentsRedirectRoute = ({ url }) => {
  const { data: tenantData, loading: tenantLoading } = useQuery(GET_CURRENT_TENANT);

  if (!tenantData || tenantLoading) {
    return <></>;
  }

  return (
    <>
      <Redirect path={url} to={`${url}/folders/${tenantData.me.currentTenant.rootFolder.id}`} />
    </>
  );
};

export default memo(SpecificationFolderContentsRedirectRoute);
